export default __webpack_public_path__ + "e442e54a0391e1df0a3b52ca7fec404e.png";